import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">venkataramanTB </span>
            from <span className="purple"> Chennai, India.</span>
            <br />I am a pursuing <span className="purple">my Bachelor degree in Computer Science</span> major <br />at Chennai Institute of Technology
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Composing Music
            </li>
            <li className="about-activity">
              <ImPointRight /> Read Technology News
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
          "Empowering the future through innovative <br />technology solutions."{" "}
          </p>
          <footer className="blockquote-footer">Venkataraman TB</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
